"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _store = _interopRequireWildcard(require("@/api/store"));
var storeApi = _store;
var _api = require("../api");
var _ZBKJIutil = require("@/utils/ZBKJIutil");
var cache;
function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var r, c, a = Object.defineProperty, n = { __proto__: null, default: e }; if (Object(e) !== e) return n; if (cache || "function" != typeof WeakMap || (cache = new WeakMap()), cache) { if (cache.has(e)) return cache.get(e); cache.set(e, n); } for (c in e) "default" !== c && {}.hasOwnProperty.call(e, c) && ((r = a && Object.getOwnPropertyDescriptor(e, c)) && (r.get || r.set) ? a(n, c, r) : n[c] = e[c]); return n; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, e) { if ("object" != _typeof(t) || !t) return t; var r; if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) { var i = r.call(t, e || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === e ? String : Number)(t); } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  props: {
    customerId: {
      type: [String, Number]
    }
  },
  data: function data() {
    return {
      merCateList: [],
      brandList: [],
      suppliers: [],
      props: {
        children: 'child',
        label: 'name',
        value: 'id',
        emitPath: false
      },
      dialogFormVisible: false,
      searchLoading: false,
      searchOptions: [],
      form: {},
      selectedSkuInfos: [],
      //选中的商品
      tableData: [],
      tableLoading: false,
      constants: this.$constants,
      listPram: {
        page: 1,
        limit: this.$constants.page.limit[0]
      },
      listData: {
        list: [],
        total: 0
      },
      totalNum: 0,
      pageLists: [],
      // 分页了的数据
      hasConfirm: null
    };
  },
  methods: {
    open: function open() {
      this.getList();
      this.hasConfirm = null;
      this.dialogFormVisible = true;
    },
    close: function close() {
      this.form = {};
      this.dialogFormVisible = false;
      this.tableData = [];
    },
    unifyUpdate: function unifyUpdate() {
      var _this = this;
      this.listPram.page = 1;
      this.tableData = this.tableData.map(function (item) {
        return _objectSpread(_objectSpread({}, item), {}, {
          supplyPrice: (0, _ZBKJIutil.Mul)(_this.form.unify || 0, item.costPrice || 0)
        });
      });
      this._handerLimit();
    },
    getList: function () {
      var _getList = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var _this2 = this;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              this.tableLoading = true;
              try {
                this.form.customerId = this.customerId;
                this.listPram.page = 1;
                (0, _api.customerSKUSearchApi)(this.form).then(function (res) {
                  _this2.tableData = res || [];
                  _this2.totalNum = res === null || res === void 0 ? void 0 : res.length;
                  _this2.tableLoading = false;
                  _this2._handerLimit();
                });
              } catch (err) {
                this.tableLoading = false;
                this.$message.error(err);
              }
            case 1:
              return _context.a(2);
          }
        }, _callee, this);
      }));
      function getList() {
        return _getList.apply(this, arguments);
      }
      return getList;
    }(),
    // 前端分页
    _handerLimit: function _handerLimit() {
      var _this$tableData;
      var resultList = [];
      if (!((_this$tableData = this.tableData) !== null && _this$tableData !== void 0 && _this$tableData.length)) {
        this.pageLists = [];
        return;
      }
      ;
      var _ref = this.listPram || {},
        _ref$limit = _ref.limit,
        limit = _ref$limit === void 0 ? 10 : _ref$limit;
      for (var i = 0; i < ((_this$tableData2 = this.tableData) === null || _this$tableData2 === void 0 ? void 0 : _this$tableData2.length); i += limit) {
        var _this$tableData2, _this$tableData3;
        resultList.push((_this$tableData3 = this.tableData) === null || _this$tableData3 === void 0 ? void 0 : _this$tableData3.slice(i, i + limit)); //将数组以3为一组平均分
      }
      ;
      this.pageLists = resultList;
    },
    handleSizeChange: function handleSizeChange(val) {
      this.listPram.limit = val;
      this._handerLimit();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.listPram.page = val;
    },
    //供应商
    remoteMethod: function remoteMethod(query) {
      this.searchLoading = true;
      if (query !== '') {
        this.getSupplierList({
          keyword: query
        });
      }
    },
    // 商品分类；
    getCategorySelect: function getCategorySelect() {
      var _this3 = this;
      (0, _store.categoryApi)({
        status: -1,
        type: 1
      }).then(function (res) {
        _this3.merCateList = res;
      }).catch(function (res) {
        _this3.$message.error(res.message);
      });
    },
    // 品牌
    getBrandList: function () {
      var _getBrandList = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(params) {
        var res, _t;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              _context2.p = 0;
              _context2.n = 1;
              return (0, _api.getBrandrApi)(params);
            case 1:
              res = _context2.v;
              this.brandList = res || [];
              _context2.n = 3;
              break;
            case 2:
              _context2.p = 2;
              _t = _context2.v;
              this.$message.error(_t);
            case 3:
              return _context2.a(2);
          }
        }, _callee2, this, [[0, 2]]);
      }));
      function getBrandList(_x) {
        return _getBrandList.apply(this, arguments);
      }
      return getBrandList;
    }(),
    //远程搜索品牌
    brandRemoteMethod: function brandRemoteMethod(query) {
      if (query !== '') {
        this.getBrandList({
          keyword: query
        });
      }
    },
    //供应商
    getSupplierList: function () {
      var _getSupplierList = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(params) {
        var res, _t2;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.p = _context3.n) {
            case 0:
              _context3.p = 0;
              _context3.n = 1;
              return (0, _api.getSupplierApi)(params);
            case 1:
              res = _context3.v;
              this.suppliers = res || [];
              _context3.n = 3;
              break;
            case 2:
              _context3.p = 2;
              _t2 = _context3.v;
              this.$message.error(_t2);
            case 3:
              return _context3.a(2);
          }
        }, _callee3, this, [[0, 2]]);
      }));
      function getSupplierList(_x2) {
        return _getSupplierList.apply(this, arguments);
      }
      return getSupplierList;
    }(),
    submitForm: function () {
      var _submitForm = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
        var _this4 = this;
        var params;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              if (!(this.selectedSkuInfos.length == 0)) {
                _context4.n = 1;
                break;
              }
              this.$message.error('请选择商品');
              return _context4.a(2);
            case 1:
              params = {
                selectedSkuInfos: this.selectedSkuInfos,
                customerId: Number(this.customerId)
              };
              (0, _api.postGoodsApi)(params, this.hasConfirm ? {
                hasConfirm: this.hasConfirm
              } : {}).then(function (res) {
                _this4.$emit('refresh');
                _this4.close();
                _this4.$message.success('操作成功');
              }).catch(function (err) {
                var _ref2 = err && err.data || {},
                  code = _ref2.code,
                  msg = _ref2.msg;
                if (code == 601 && !_this4.hasConfirm) {
                  storeApi.checkComfirm(msg).then(function (res) {
                    _this4.hasConfirm = res && res.hasConfirm;
                    _this4.submitForm();
                  });
                }
              });
            case 2:
              return _context4.a(2);
          }
        }, _callee4, this);
      }));
      function submitForm() {
        return _submitForm.apply(this, arguments);
      }
      return submitForm;
    }(),
    //选中的商品
    handleSelectionChange: function handleSelectionChange(list) {
      this.selectedSkuInfos = list;
    }
  },
  created: function created() {
    this.remoteMethod();
    this.brandRemoteMethod();
    this.getCategorySelect();
    this.getSupplierList();
  }
};